import React from "react";

function SVGImage({ className }) {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 800.4 496.3"
      style={{ enableBackground: "new 0 0 615.8 496.3" }}
      xmlSpace="preserve"
      className={className}
    >
      <style type="text/css">
        {`
          .set1 { fill: #3F3D56; }
          .set2 { fill: #F2F2F2; }
          .set3 { fill: #CCCCCC; }
          .set4 { fill: #FFC803; }
          .set5 { fill: #01010C; }
        `}
      </style>
      <g>
        <path
          className="set1"
          d="M415.4,463.7c-48.4,0-94.1-15.2-132.2-44l1.2-1.4c37.7,28.5,83,43.6,131,43.6s93.4-15.1,131.1-43.7l1.2,1.4
		C509.6,448.5,463.9,463.7,415.4,463.7L415.4,463.7z"
        />
        <g>
          <path
            className="set2"
            d="M630.7,402c1.9,0.1,2.9-2.2,1.5-3.6l-0.1-0.6c0,0,0-0.1,0.1-0.1c1.9-4.5,8.3-4.5,10.2,0
			c1.7,4,3.8,8.1,4.3,12.3c0.2,1.9,0.1,3.8-0.3,5.6c3.9-8.6,6-17.9,6-27.3c0-2.4-0.1-4.7-0.4-7.1c-0.2-1.9-0.5-3.8-0.9-5.7
			c-2.1-10.2-6.6-20-13.2-28.2c-3.1-1.7-5.8-4.4-7.4-7.6c-0.6-1.2-1-2.4-1.2-3.7c0.4,0,1.3-5.4,1.1-5.7c0.5-0.8,1.4-1.1,1.9-1.9
			c2.7-3.7,6.4-3,8.4,2c4.2,2.1,4.2,5.6,1.6,8.9c-1.6,2.1-1.8,5-3.3,7.3c0.1,0.2,0.3,0.4,0.4,0.6c2.7,3.5,5,7.2,7,11.1
			c-0.6-4.3,0.3-9.5,1.7-12.9c1.6-3.8,4.6-7.1,7.2-10.4c3.1-4,9.6-2.2,10.2,2.8v0.1c-0.4,0.2-0.8,0.5-1.1,0.7
			c-2.1,1.4-1.4,4.7,1.1,5.1h0.1c-0.1,1.4-0.4,2.8-0.7,4.2c3.4,13-3.9,17.7-14.3,18c-0.2,0.1-0.5,0.2-0.7,0.3c1.1,3,1.9,6,2.5,9.1
			c0.6,2.7,0.9,5.5,1.2,8.2c0.3,3.5,0.2,7,0,10.5v-0.1c0.7-3.8,2.8-7.4,5.8-9.9c4.5-3.7,10.8-5.1,15.7-8c2.3-1.4,5.3,0.4,4.9,3.1
			v0.1c-0.7,0.3-1.4,0.6-2.1,1c-0.4,0.2-0.8,0.5-1.1,0.7c-2.1,1.4-1.4,4.7,1.1,5.1h0.1h0.1c-1.2,2.9-3,5.7-5.1,8
			c-2.1,11.4-11.1,12.4-20.8,9.1l0,0c-1.1,4.6-2.6,9.1-4.6,13.4h-16.4c-0.1-0.2-0.1-0.4-0.2-0.6c1.5,0.1,3,0,4.5-0.3
			c-1.2-1.5-2.4-3-3.6-4.5l-0.1-0.1c-0.6-0.8-1.2-1.5-1.9-2.3l0,0C629.8,406.6,630.1,404.3,630.7,402L630.7,402L630.7,402z"
          />
          <path
            className="set2"
            d="M169.8,402c-1.9,0.1-2.9-2.2-1.5-3.6l0.1-0.6c0,0,0-0.1-0.1-0.1c-1.9-4.5-8.3-4.5-10.2,0
			c-1.7,4-3.8,8.1-4.3,12.3c-0.2,1.9-0.1,3.8,0.3,5.6c-3.9-8.6-6-17.9-6-27.3c0-2.4,0.1-4.7,0.4-7.1c0.2-1.9,0.5-3.8,0.9-5.7
			c2.1-10.2,6.6-20,13.2-28.2c3.1-1.7,5.8-4.4,7.4-7.6c0.6-1.2,1-2.4,1.2-3.7c-0.4,0-1.3-5.4-1.1-5.7c-0.5-0.8-1.4-1.1-1.9-1.9
			c-2.7-3.7-6.4-3-8.4,2c-4.2,2.1-4.2,5.6-1.6,8.9c1.6,2.1,1.8,5,3.3,7.3c-0.1,0.2-0.3,0.4-0.4,0.6c-2.7,3.5-5,7.2-7,11.1
			c0.6-4.3-0.3-9.5-1.7-12.9c-1.6-3.8-4.6-7.1-7.2-10.4c-3.1-4-9.6-2.2-10.2,2.8v0.1c0.4,0.2,0.8,0.5,1.1,0.7
			c2.1,1.4,1.4,4.7-1.1,5.1h-0.1c0.1,1.4,0.4,2.8,0.7,4.2c-3.4,13,3.9,17.7,14.3,18c0.2,0.1,0.5,0.2,0.7,0.3c-1.1,3-1.9,6-2.5,9.1
			c-0.6,2.7-0.9,5.5-1.2,8.2c-0.3,3.5-0.2,7,0,10.5v-0.1c-0.7-3.8-2.8-7.4-5.8-9.9c-4.5-3.7-10.8-5.1-15.7-8
			c-2.3-1.4-5.3,0.4-4.9,3.1v0.1c0.7,0.3,1.4,0.6,2.1,1c0.4,0.2,0.8,0.5,1.1,0.7c2.1,1.4,1.4,4.7-1.1,5.1h-0.1h-0.1
			c1.2,2.9,3,5.7,5.1,8c2.1,11.4,11.1,12.4,20.8,9.1l0,0c1.1,4.6,2.6,9.1,4.6,13.4h16.4c0.1-0.2,0.1-0.4,0.2-0.6
			c-1.5,0.1-3,0-4.5-0.3c1.2-1.5,2.4-3,3.6-4.5l0.1-0.1c0.6-0.8,1.2-1.5,1.9-2.3l0,0C170.6,406.6,170.3,404.3,169.8,402L169.8,402
			L169.8,402z"
          />
          <path
            className="set2"
            d="M257.3,418.9l-0.8,0.9c-29.8-25.4-46.9-62.5-46.9-101.7c0-35.7,13.9-69.2,39.1-94.5
			c25.2-25.2,58.8-39.1,94.5-39.1s69.2,13.9,94.5,39.1c25.2,25.2,39.1,58.8,39.1,94.5c0,39.2-17.1,76.2-46.9,101.7l-0.8-0.9"
          />
          <path
            className="set1"
            d="M549.7,418.4l-1.2-1.4c45.6-38.9,71.8-95.6,71.8-155.6C620.4,148.7,528.6,57,415.9,57
			s-204.5,91.7-204.5,204.5c0,60,26.2,116.7,71.8,155.6l-1.2,1.4c-46.1-39.3-72.5-96.5-72.5-157c0-55.1,21.5-106.9,60.4-145.9
			c39-39,90.8-60.4,145.9-60.4s106.9,21.5,145.9,60.4c39,39,60.4,90.8,60.4,145.9C622.2,321.9,595.8,379.1,549.7,418.4L549.7,418.4z
			"
          />
          <path
            className="set3"
            d="M479.3,418c0,0.6,0.5,1.1,1.1,1.1h198.4c0.6,0,1.1-0.5,1.1-1.1s-0.5-1.1-1.1-1.1H480.4
			C479.8,416.9,479.3,417.4,479.3,418z"
          />
          <rect x="415" y="56" className="set1" width="1.8" height="63.1" />
          <rect
            x="211.7"
            y="258.4"
            className="set1"
            width="63.1"
            height="1.8"
          />

          <rect
            x="299.6"
            y="99.7"
            transform="matrix(0.7747 -0.6323 0.6323 0.7747 -15.2759 219.5777)"
            className="set1"
            width="1.8"
            height="63.1"
          />

          <rect
            x="243.5"
            y="362.9"
            transform="matrix(0.7746 -0.6325 0.6325 0.7746 -168.1005 255.9641)"
            className="set1"
            width="63.1"
            height="1.8"
          />
          <rect x="557" y="258.4" className="set1" width="63.1" height="1.8" />

          <rect
            x="499.8"
            y="130.2"
            transform="matrix(0.6322 -0.7748 0.7748 0.6322 93.7977 459.8943)"
            className="set1"
            width="63.1"
            height="1.8"
          />

          <rect
            x="555.8"
            y="332.3"
            transform="matrix(0.6323 -0.7747 0.7747 0.6323 -77.2172 565.0967)"
            className="set1"
            width="1.8"
            height="63.1"
          />
          <circle className="set1" cx="415.9" cy="255" r="25.4" />
          <circle className="set1" cx="533.1" cy="343.2" r="9.1" />
          <circle className="set1" cx="553.1" cy="261.4" r="9.1" />
          <circle className="set1" cx="509.5" cy="156" r="9.1" />
          <circle className="set1" cx="415" cy="121.5" r="9.1" />
          <circle className="set1" cx="321.4" cy="156" r="9.1" />
          <circle className="set1" cx="275.1" cy="258.7" r="9.1" />
          <circle className="set1" cx="300.5" cy="342.3" r="9.1" />
          <g>
            <circle className="set1" cx="366" cy="256.9" r="9.1" />
            <path
              className="set4"
              d="M372.3,249.9l203.4-8.8c3.5-0.2,6.5,2.6,6.6,6.1l0,0c0.2,3.5-2.6,6.5-6.1,6.6l-203.4,8.8
				c-3.5,0.2-6.5-2.6-6.6-6.1l0,0C366.1,253.1,368.8,250.1,372.3,249.9z"
            />
          </g>
          <path
            className="set3"
            d="M414.8,495.3c0,0.6,0.5,1.1,1.1,1.1h198.4c0.6,0,1.1-0.5,1.1-1.1s-0.5-1.1-1.1-1.1H415.9
			C415.3,494.2,414.8,494.7,414.8,495.3z"
          />
          <path
            className="set3"
            d="M120.4,418c0,0.6,0.5,1.1,1.1,1.1h198.4c0.6,0,1.1-0.5,1.1-1.1s-0.5-1.1-1.1-1.1H121.5
			C120.9,416.9,120.4,417.4,120.4,418z"
          />
        </g>
      </g>
      <g>
        <g>
          <path
            className="set5"
            d="M699.3,122.4c1,1.6,3.8,0.1,2.6-1.6c-12.9-19.6-25.7-39.3-38.6-58.9c-1.5-2.2-2.9-4.2-4.1-6.6
			c-1.2-2.3-1.3-4.2-1.3-6.9c0-2.3-0.1-4.7,0.3-7c0.4-2,1.8-2.8,3.8-2.8c1.6,0,3.2,0.4,4.8,0.9c1.9,0.6,4.2,0.9,6,1.9
			c3.9,2.3,7,6.7,10.1,10.1c3.5,3.8,7.2,7.6,10.7,11.4c7,7.5,14,14.9,21.1,22.2c3.5,3.8,7.2,7.6,10.7,11.4c1.8,1.9,3.4,3.5,5.6,5
			c2.2,1.3,4.4,2.6,6.4,3.9c1.5,1,2.2,2,1,3.7c-0.4,0.6-1,1-1.6,1.3c-0.7,0.6-1.6,1.3-2.3,1.9c-2.3,1.9-4.7,3.8-7.2,5.7
			c-5.1,4.1-10.2,8.2-15.5,12.3c-1,0.9-2,1.6-3.1,2.5c-0.4,0.3-0.9,0.7-1.2,1c-1.2,0.9-1.9,1.5-2.6-0.3c-1-2.3-1.2-5.3-1.8-7.8
			c-0.3-1.6-0.4-3.9-1.5-5.3c-1.2-1.6-3.4,0.6-2.2,2.2c0.1,0.1,0.3,1.9,0.3,2.3c0.1,0.9,0.4,1.6,0.6,2.5c0.3,1.5,0.7,2.9,1,4.4
			c0.4,1.9,0.7,4.5,2.8,5.6c3.1,1.6,6.4-2.3,8.6-4.1c6.4-5.1,13-10.2,19.5-15.4c3.5-2.8,14.2-8.8,8.5-14c-1.9-1.8-4.4-2.9-6.4-4.2
			c-2.8-1.8-4.8-3.5-7-5.9c-4.1-4.4-8.2-8.8-12.4-13.2c-8-8.5-16.2-17-24.3-25.6c-3.9-4.2-7.8-8.5-11.8-12.6
			c-1.5-1.6-3.2-3.2-5.1-4.2c-1.9-1-4.1-1.3-6-1.9c-4.8-1.3-11-1.9-12.4,4.1c-0.6,2.6-0.3,5.4-0.4,8c-0.1,5.4,2.2,9.1,5,13.5
			C672.9,82.2,686.1,102.3,699.3,122.4L699.3,122.4z"
          />
          <path
            className="set5"
            d="M709.2,73.9c-2,0-2,3.1,0,3.1c7.6,0.3,15.1,0.4,22.7,0.7c3.4,0.1,7.8-0.4,10.8,1.3c2.6,1.5,4.2,4.4,5.7,6.9
			l0.3-1.9c-5.6,4.4-11.1,8.8-16.7,13.2c-1.6,1.2,0.6,3.4,2.2,2.2c5.6-4.4,11.1-8.8,16.7-13.2c0.6-0.4,0.6-1.3,0.3-1.9
			c-1.5-2.8-3.2-5.6-5.7-7.3c-3.1-2.2-6.7-2-10.2-2.2C726.5,74.5,717.8,74.2,709.2,73.9L709.2,73.9z"
          />
          <path
            className="set5"
            d="M684.9,95.7L684.9,95.7c0.4-1.9-2.6-2.8-2.9-0.9c-1.8,8.2-3.5,16.4-5.3,24.6c-0.7,3.5-1.9,7.2-0.7,10.8
			c1,3.2,3.5,5.7,5.9,7.9c0.7,0.6,1.5,0.6,2.2,0c5.6-4.4,11.3-8.6,16.8-13c1.6-1.2-0.6-3.4-2.2-2.2c-5.6,4.4-11.3,8.6-16.8,13h2.2
			c-2.3-2.2-5.1-4.7-5.6-8.2c-0.4-3.5,1-7.3,1.8-10.7C681.9,110,683.3,102.8,684.9,95.7L684.9,95.7z"
          />
          <path
            className="set5"
            d="M725.6,123.3c-0.9-0.1-1.6,0.1-1.9,1c-0.1,0.7,0.3,1.8,1,1.9c4.5,0.6,10.2,1.3,12.7,5.9
			c1.3,2.3,1.3,5.4,1.6,8c0.4,2.9,0.7,5.7,1.2,8.6l1.9-1.9c-2.8-0.9-5.9-0.7-8.8-0.7c-2.8,0-5.6-0.3-7.6-2.3
			c-4.5-4.5-2.6-11.7-1.2-17.1c0.6-1.9-2.5-2.8-2.9-0.9c-1.8,6.4-3.2,14,1.6,19.6c2.2,2.5,5.3,3.5,8.5,3.7s6.6-0.3,9.8,0.6
			c1.3,0.4,2-0.7,1.9-1.9c-0.4-3.2-0.9-6.4-1.3-9.7c-0.4-2.8-0.6-5.7-2.2-8.2C736.7,125.1,731,124,725.6,123.3L725.6,123.3z"
          />
        </g>
        <path
          className="set5"
          d="M674.4,55.2c0.4,0,0.7-0.1,1-0.4s0.4-0.7,0.4-1c0-0.4-0.1-0.9-0.4-1c-0.3-0.3-0.7-0.4-1-0.4
		c-0.6,0-1.3,0.1-1.9,0.1c-0.4,0-0.9,0.1-1.3,0.3c-0.6,0.3-1,0.6-1.5,1.2c-0.3,0.3-0.4,0.7-0.6,1.2c-0.1,0.4-0.3,0.9-0.4,1.3
		c-0.3,0.9,0.3,1.6,1,1.9c0.4,0.1,0.9,0,1.2-0.1s0.6-0.6,0.7-0.9c0.1-0.6,0.3-1.2,0.6-1.6l-0.1,0.4c0.1-0.1,0.1-0.4,0.3-0.6
		l-0.3,0.3c0-0.1,0.1-0.1,0.1-0.1l-0.3,0.3c0.1,0,0.1-0.1,0.3-0.1l-0.4,0.1c0.3-0.1,0.6-0.1,0.9-0.1h-0.4
		C673.1,55.3,673.7,55.3,674.4,55.2L674.4,55.2z"
        />
      </g>
      <g>
        <path
          className="set5"
          d="M144.6,56.3c-0.9,2.5,2.8,4.2,3.7,1.7c5.1-14.3,10-28.5,15.1-42.8c0.4-1.4-0.4-3.1-2.1-3
		c-1.8,0.2-3.6,0.3-5.2,0.5c-12.4,1.1-24.7,2.2-37.1,3.3c-2.5,0.2-2.2,4.4,0.4,4.2c1.8-0.2,3.6-0.3,5.2-0.5
		c12.4-1.1,24.7-2.2,37.1-3.3l-2.1-3C154.6,27.8,149.7,42,144.6,56.3L144.6,56.3z"
        />
        <path
          className="set5"
          d="M143.2,199.3L143.2,199.3c1.3,2.4,4.5-0.2,3.3-2.5c-12.6-23-12.9-53-0.1-76.2c6.1-11.3,17.2-21.8,30.5-18.5
		c5.7,1.4,10.6,5.5,12.1,11.4c1.5,5.8-0.6,12.1-3.9,16.8c-7.6,10.8-21.8,14.1-33.5,17.4c-10.5,3-22.3,5.5-32.9,1.6
		c-11.4-4.2-18.1-16-19.7-28.2c-1.6-12.9,2.4-25.7,7.8-37c12.1-24.9,30.1-47.2,50.4-65.2c1.9-1.7-0.4-5.2-2.4-3.4
		c-13.6,12.1-25.9,25.7-36.2,40.9c-9.3,13.3-18.1,28.1-22.1,44.2c-3.3,13.3-2.4,27.7,4.8,39.5c6.9,11.1,18.4,16,30.8,15.7
		c6.3-0.2,12.4-1.6,18.5-3.1c7.2-1.9,14.4-3.9,21.1-6.9c11.1-4.9,21.8-14.6,21.7-28.2c0-13.2-12-21-23.6-20.1
		c-13.8,1.1-23.6,13.8-29.3,26C129.5,147.2,130.8,176.2,143.2,199.3L143.2,199.3z"
        />
      </g>
    </svg>
  );
}

export default SVGImage;
